module.exports = __webpack_public_path__ + "static/media/soilder.2b1ab690.jpg";